module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"following":"Følger","change":"endre"},"en":{"following":"Following","change":"change"}}')
  delete Component.options._Ctor
}
